import React from "react";

export default function App() {
  return (
    <div className="bg-white text-gray-800 font-sans">
      {/* Hero Section */}
      <header className="min-h-screen flex flex-col justify-center items-center bg-gray-50 px-6 text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          Presentations That Speak the CFO & CEO's Language
        </h1>
        <p className="text-lg md:text-xl mb-6 max-w-2xl">
          Built by a team of CAs and CFAs who live and breathe finance — we blend strategy, clarity, and visuals into every boardroom-ready deck.
        </p>
        <a
          href="mailto:akku.1291@gmail.com?subject=Sample Deck Request&body=Hi,I'd love to receive a sample deck. My email is: [your email here].Thanks!"
          className="bg-black text-white px-6 py-3 rounded-full hover:bg-gray-800 transition"
          aria-label="Request a sample presentation deck"
        >
          Get a Sample
        </a>
      </header>

      {/* Services Section */}
      <section className="py-20 px-6 bg-white text-center" id="services">
        <h2 className="text-3xl font-bold text-center mb-10">What We Do</h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <ServiceCard title="Strategic & Financial Storytelling" />
          <ServiceCard title="Board Meeting Decks" />
          <ServiceCard title="M&A / Investor Presentations" />
          <ServiceCard title="KPI Dashboards & Data Visuals" />
        </div>
      </section>

      {/* Why Us Section */}
      <section className="py-20 px-6 bg-gray-100 text-center" id="about">
        <h2 className="text-3xl font-bold mb-6">Why Work With Us</h2>
        <p className="max-w-2xl mx-auto text-lg">
          We're a team of CAs & CFAs who live and breathe numbers, finance, and visual storytelling. 
          We don't just "make slides"—we understand exactly what to say, how to say it, and where to say it 
          on the slide to get your board nodding. You bring the data, we bring the clarity. 
          We skip the fluff. We skip the stock icons. We design with intent.
        </p>
      </section>

      {/* Sample Work Section */}
      <section className="py-20 px-6 bg-white text-center" id="samples">
        <h2 className="text-3xl font-bold mb-6">Sample Slides</h2>
        <p className="text-lg text-gray-600 mb-8">
          Coming soon: See examples of real-world decks designed for CFOs and finance leaders.
        </p>
        <div className="text-gray-400 text-4xl">[ Slide Previews Placeholder ]</div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6 bg-gray-100 text-center" id="testimonials">
        <h2 className="text-3xl font-bold mb-10">What People Say</h2>
        <blockquote className="max-w-2xl mx-auto">
          <p className="text-xl italic mb-4">
            "Incredible clarity and polish. Took our raw numbers and turned them into a compelling story."
          </p>
          <cite className="text-gray-600">– CFO, UAE-based Aviation Company</cite>
        </blockquote>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-6 bg-white text-center" id="contact">
        <h2 className="text-3xl font-bold mb-6">Let's Build Your Next Deck</h2>
        <p className="text-lg mb-8">Drop a message or request a sample. I'll get back to you personally.</p>
        
        <div className="max-w-md mx-auto mb-8">
          <input
            type="email"
            name="Email"
            placeholder="Your Email"
            required
            className="w-full px-4 py-2 mb-4 rounded text-black border border-gray-300"
            aria-label="Enter your email address"
          />
          <textarea
            name="Message"
            placeholder="Your Message"
            className="w-full px-4 py-2 mb-4 rounded text-black border border-gray-300"
            rows="4"
            aria-label="Enter your message"
          ></textarea>
          <button className="bg-black text-white px-8 py-3 rounded hover:bg-gray-800 transition w-full">
            Send
          </button>
        </div>
        
        <div className="flex justify-center gap-4 flex-wrap">
          <a
            href="https://calendly.com/akku-1291/30min"
            className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Book a consultation call"
          >
            Book a Call
          </a>
          <a
            href="https://wa.me/917030623230"
            className="bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700 transition"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
          >
            Chat on WhatsApp
          </a>
        </div>
      </section>

      {/* New Subpages */}
      <section className="py-20 px-6 bg-gray-100 text-center" id="explore">
        <h2 className="text-3xl font-bold mb-10">Explore More</h2>
        <nav className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto" aria-label="Additional pages">
          <SubPageCard title="About Our Team" link="/#about" />
          <SubPageCard title="Design Philosophy" link="/#philosophy" />
          <SubPageCard title="Before & After Slides" link="/#before-after" />
        </nav>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-8 text-center">
        <p>&copy; {new Date().getFullYear()} CEO Deck Studio. All rights reserved.</p>
        <nav className="mt-4 flex justify-center gap-6" aria-label="Footer navigation">
          <a href="/#services" className="hover:underline">Services</a>
          <a href="/#about" className="hover:underline">About</a>
          <a href="/#contact" className="hover:underline">Contact</a>
        </nav>
      </footer>
    </div>
  );
}

function ServiceCard({ title }) {
  return (
    <div className="p-6 border rounded hover:shadow-lg transition">
      <h3 className="font-bold text-xl">{title}</h3>
    </div>
  );
}

function SubPageCard({ title, link }) {
  return (
    <a
      href={link}
      className="block p-6 border rounded hover:shadow-lg transition bg-white"
    >
      <h4 className="font-bold">{title}</h4>
    </a>
  );
}
